import careerService from '../../services/careerService/service';
import careerModel from '../../models/careerModel/model';

export default {
    async fetchCareers(search, page, limit, company){
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const {data, headers} = await careerService.getCareers(sanitizedSearch, page, limit, company);
            return {
                data: data.map(career => new careerModel(career)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching careers:', error);
            throw error;
        }
    },
    async getCareerDetail(id){
        try {
            const data = await careerService.getCareerDetail(id);
            return data.data;
        } catch (error) {
            console.error('Error fetching careers:', error);
            throw error;
        }
    },
    async totalAllCareers(search, company){
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await careerService.totalAllCareers(sanitizedSearch, company);
        } catch (error) {
            console.error('Error fetching careers:', error);
            throw error;
        }
    },
    async totalAllCareersActive(search, company_id){
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await careerService.totalAllCareersActive(sanitizedSearch, company_id);
        } catch (error) {
            console.error('Error fetching careers:', error);
            throw error;
        }
    },
    async updateCareer(career){
        try {
            return await careerService.updateCareer(career);
        } catch (error) {
            console.error('Error updating career:', error);
            throw error;
        }
    },
    async addCareer(career){
        try {
            return await careerService.addCareer(career);
        } catch (error) {
            console.error('Error adding career:', error);
            throw error;
        }
    },
    async deleteCareer(careerId){
        try {
            return await careerService.deleteCareer(careerId);
        } catch (error) {
            console.error('Error deleting career:', error);
            throw error;
        }
    },
    async updateStatusCareerDetail(requirement){
        try {
            return await careerService.updateStatusCareerDetail(requirement);
        } catch (error) {
            console.error('Error updating requirement:', error);
            throw error;
        }
    }
}